import React from 'react';

import { PageLayout } from 'common/components';

import { staticStyles } from './style';

const EMAIL_ALERTS_URL =
  'https://dol.tradingbull.ai/subscribeemail?language=english&ispublic=true&theme=dolphin&channel=dolphin&public=public';

// 与 Trade Hub 同一定案：外部页不发 iframeResize、跨域测不到内容高，iframe 恒 100vh 内部滚动（见 style.js）。
// 曾尝试“订阅跳转时 load 事件→切 100vh”，但已订阅用户首载即确认卡（守卫会跳过）、且更新订阅为 AJAX 无跳转，检测不可靠故移除
const EmailAlertsPage = () => (
  <PageLayout captionSlug="emailAlerts">
    <div className="EmailAlertsPage">
      <iframe
        src={EMAIL_ALERTS_URL}
        title="Email alerts"
        allow="autoplay; encrypted-media; picture-in-picture"
        allowFullScreen
      />
    </div>
    <style jsx global>
      {staticStyles}
    </style>
  </PageLayout>
);

export default EmailAlertsPage;
